import React from 'react'

const GlobalEventsContext = React.createContext()

export default GlobalEventsContext
